import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import SynQuestSystemShortInterviewDto = MdbsCore.SynQuestSystemShortInterviewDto;
import SynQuestSystemApiClient = MdbsCore.SynQuestSystemApiClient;
import ISynQuestSystemAuthLoginUserDto = MdbsCore.ISynQuestSystemAuthLoginUserDto;
import SynQuestSystemAuthLoginUserDto = MdbsCore.SynQuestSystemAuthLoginUserDto;
import ISynQuestSystemAuthLoginPatientDto = MdbsCore.ISynQuestSystemAuthLoginPatientDto;
import SynQuestSystemAuthLoginPatientDto = MdbsCore.SynQuestSystemAuthLoginPatientDto;
import SynQuestLoginResponseDto = MdbsCore.SynQuestLoginResponseDto;
import ApiException = MdbsCore.ApiException;

const client = new SynQuestSystemApiClient();

@Module({namespaced: true, name: 'synQuestInterview', store: store})
export default class SynQuestInterviewModule extends BaseModule {
    interview: SynQuestSystemShortInterviewDto = new SynQuestSystemShortInterviewDto();
    patientLogin: SynQuestLoginResponseDto = new SynQuestLoginResponseDto();
    userLogin: SynQuestLoginResponseDto = new SynQuestLoginResponseDto();

    get isUserLoggedIn(): boolean {
        return this.userLogin?.token != undefined;
    }

    get isPatientLoggedIn(): boolean {
        return this.patientLogin?.token != undefined;
    }

    @Mutation
    setInterview(interview: SynQuestSystemShortInterviewDto) {
        this.interview = interview;
    }

    @Mutation
    setUserLogin(userLogin: SynQuestLoginResponseDto) {
        this.userLogin = userLogin;
    }


    @Mutation
    setPatientLogin(patientLogin: SynQuestLoginResponseDto) {
        this.patientLogin = patientLogin;
    }

    @Mutation
    reset() {
        this.interview = new SynQuestSystemShortInterviewDto();
        this.userLogin = new SynQuestLoginResponseDto();
        this.patientLogin = new SynQuestLoginResponseDto();
    }

    @Action({rawError: true})
    async loadByInstrumentId(instrumentId: string) {
        if (instrumentId == "") {
            this.reset();
            return;
        }

        await this.execute(async () => {
            try {
                const interview = await client.getInterview(instrumentId, true);
                this.setInterview(interview);
            } catch (e) {
                this.reset();

                if (ApiException.isApiException(e) && e.status != 404) {
                    throw e;
                }
            }
        }).catch(() => this.reset());
    }

    @Action({rawError: true})
    async loginUser(loginDto: ISynQuestSystemAuthLoginUserDto) {
        await this.execute(async () => {
            this.setUserLogin(await client.userLogin(new SynQuestSystemAuthLoginUserDto(loginDto)))
        }).catch();
    }

    @Action({rawError: true})
    async loginPatient(loginDto: ISynQuestSystemAuthLoginPatientDto) {
        await this.execute(async () => {
            this.setPatientLogin(await client.patientLogin(new SynQuestSystemAuthLoginPatientDto(loginDto)))
        }).catch();
    }
}
